<script>
import baseMixin from '@/mixins/baseMixin'
import TruncatedChipList from './truncated-chip-list.vue'

export default {
  name: 'TruncatedChipTooltip',
  components: { TruncatedChipList },
  mixins: [baseMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * The number of items shown before being truncated
     */
    limit: {
      type: Number,
      default: 10,
    },
  },
}
</script>

<template>
  <v-tooltip :disabled="items.length === 0" top>
    <template v-slot:activator="{ on: onTooltip }">
      <slot :onTooltip="onTooltip"> </slot>
    </template>
    <div style="max-width: 400px">
      <TruncatedChipList
        :items="items"
        :limit="limit"
        :small="true"
        :color="isDarkMode ? 'grey darken-1' : 'grey darken-4'"
      />
    </div>
  </v-tooltip>
</template>
